import { render } from "./CategoryManageCreatePage.vue?vue&type=template&id=4299d56b&lang=true"
import script from "./CategoryManageCreatePage.vue?vue&type=script&lang=js"
export * from "./CategoryManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__